export const getHostFromEmail = (email: string): string | undefined => {
	const [, host] = email.split('@');

	return host;
};
